<template>
  <div class="job-list-item__req-item">
    <img
      v-if="img_icon_name"
      :src="`/images/icons/${img_icon_name}.svg`"
      :alt="img_icon_name">
    <component
      :is="slot_tag"
      :class="{loader: loading}">
      <slot></slot>
    </component>
  </div>
</template>

<script>

export default {
  name: 'JobItemRequirements',
  props: {
    /**
     * path /images/icons/
     * resolution .svg
     */
    img_icon_name: {
      type: String,
      default: '',
      required: true
    },
    slot_tag: {
      type: String,
      default: 'span'
    },
    loading: {
      type: Boolean,
      default: false
    },
  }
}
</script>
